import { Observable, BehaviorSubject, merge, concat, of, SchedulerLike as IScheduler } from 'rxjs';
import { map, mapTo, exhaustMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { RecurringTaskAction } from '../models/recurring-task.action';
import { BackgroundTaskFactory } from '../../background-task/background-task.factory';
import { IFetchStrategy } from './i-fetch.strategy';

@Injectable({ providedIn: 'root' })
export class BackgroundFetchStrategy implements IFetchStrategy {
  public constructor(private readonly backgroundTaskFactory: BackgroundTaskFactory) {}

  public startRecurringTask<TParameters, TResult>(
    fetchData: (parameters: TParameters, intervalId: number, preload: boolean) => Observable<TResult>,
    parameters: TParameters,
    interval: number,
    firstInterval: number,
    action$: BehaviorSubject<RecurringTaskAction>,
    scheduler?: IScheduler,
  ): Observable<TResult> {
    return merge(
      of(0),
      concat(
        this.backgroundTaskFactory.createDelayTask(firstInterval || interval, scheduler).pipe(mapTo(1)),
        this.backgroundTaskFactory.createIntervalTask(interval, scheduler).pipe(map((intervalId) => intervalId + 2)),
      ),
    ).pipe(
      exhaustMap((intervalId) => fetchData(parameters, intervalId, intervalId === 0)),
      this.backgroundTaskFactory.toBackground(),
    );
  }
}
